<template>
  <div id="vBox" v-cloak>
    <div style="">
      <div id="container">
        <div class="header">
          <div class="hInner">
            <div class="logo">
              <a>
                <img :src="fklhj_logo" alt="" />
              </a>
            </div>
            <ul class="clearfix">
              <li class="li01" v-if="info.username">
                {{ $t('hy') }},<span class="expandable-text" @click="toggleText" :data-full-text="info.username">{{
                  truncateText(info.username) }}</span>
              </li>
              <li v-if="info.username">
                <span style="color: #afafaf;" @click="logOut">{{ $t('dc') }}</span>
              </li>
              <li class="li01" v-else @click="logFun">
                {{ $t('wdl') }}
              </li>
              <li class="li02" v-if="info.username">
                {{ $t('sys') }}：{{ remain }}
              </li>
              <li class="li03" @click="showDetail">
                <img src="~@/assets/search.png" />
                {{ $t('lhjcy') }}
              </li>
              <li class="li03">
                <a :href="onLink" target="_blank">{{ $t('zxkf') }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div id="main">
          <!-- 抽奖容器 -->
          <div id="luck" ref="luck" v-if="giftArr.length > 0">
            <table>
              <tbody>
                <tr>
                  <td class="luck-unit luck-unit-0">
                    <div class="item" v-if="giftArr[0]">
                      <img :src="giftArr[0].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[0].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-1">
                    <div class="item" v-if="giftArr[1]">
                      <img :src="giftArr[1].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[1].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-2">
                    <div class="item" v-if="giftArr[2]">
                      <img :src="giftArr[2].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[2].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-3">
                    <div class="item" v-if="giftArr[3]">
                      <img :src="giftArr[3].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[3].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-4">
                    <div class="item" v-if="giftArr[4]">
                      <img :src="giftArr[4].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[4].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-5">
                    <div class="item" v-if="giftArr[5]">
                      <img :src="giftArr[5].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[5].title) }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="luck-unit luck-unit-17">
                    <div class="item" v-if="giftArr[17]">
                      <img :src="giftArr[17].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[17].title) }}</span>
                    </div>
                  </td>
                  <td rowspan="3" colspan="4">
                    <div class="box">
                      <div class="img" style="height: 254px;">
                        <img src="~@/assets/img05.png" alt="" v-if="lang==='cn'" />
                        <img src="~@/assets/img05e.png" alt="" v-if="lang==='en'" height="168" />
                        <a href="javascript:;" class="cjBtn" @click="handleLuckySpinAward">
                          <img src="~@/assets/btn.png" alt="" v-if="lang==='cn'" />
                          <img src="~@/assets/btne.png" alt="" v-if="lang==='en'" height="95" />
                        </a>
                      </div>
                      <div class="dateBox clearfix" style="">
                        <div class="txt">
                          <img :src="computedImage" alt="" width="394" />
                        </div>
                        <div class="date">
                          <span>
                            <span id="date01">0</span>{{ $t('t') }}
                          </span><span>
                            <span id="date02">0</span>{{ $t('h') }}
                          </span><span>
                            <span id="date03">0</span>{{ $t('m') }}
                          </span><span>
                            <span id="date04">0</span>{{ $t('s') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-6">
                    <div class="item" v-if="giftArr[6]">
                      <img :src="giftArr[6].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[6].title) }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="luck-unit luck-unit-16">
                    <div class="item" v-if="giftArr[16]">
                      <img :src="giftArr[16].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[16].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-7">
                    <div class="item" v-if="giftArr[7]">
                      <img :src="giftArr[7].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[7].title) }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="luck-unit luck-unit-15">
                    <div class="item" v-if="giftArr[15]">
                      <img :src="giftArr[15].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[15].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-8">
                    <div class="item" v-if="giftArr[8]">
                      <img :src="giftArr[8].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[8].title) }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="luck-unit luck-unit-14">
                    <div class="item" v-if="giftArr[14]">
                      <img :src="giftArr[14].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[14].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-13">
                    <div class="item" v-if="giftArr[13]">
                      <img :src="giftArr[13].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[13].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-12">
                    <div class="item" v-if="giftArr[12]">
                      <img :src="giftArr[12].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[12].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-11">
                    <div class="item" v-if="giftArr[11]">
                      <img :src="giftArr[11].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[11].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-10">
                    <div class="item" v-if="giftArr[10]">
                      <img :src="giftArr[10].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[10].title) }}</span>
                    </div>
                  </td>
                  <td class="luck-unit luck-unit-9">
                    <div class="item" v-if="giftArr[9]">
                      <img :src="giftArr[9].img" alt="" />
                      <span>{{ formatPrizeName(giftArr[9].title) }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 老虎机查询 -->
          <div id="msgDiv" class="searchBox" v-show="search.dialogShow">
            <div class="close">
              <a href="javascript:;" @click="closeSearchDialog">
                <img src="~@/assets/close02.png" alt="" />
              </a>
            </div>
            <h1 style="">{{ $t('lhjcy') }}</h1>
            <div class="record_contaniner">
              <table>
                <tbody>
                  <tr>
                    <th>{{ $t('xzt') }}</th>
                    <th>{{ $t('jp') }}</th>
                  </tr>
                  <tr v-for="(item, index) in search.history_list" v-show="search.result_show == 1" :key="index">
                    <td>
                      {{ getDateFormatter(item.create_time) }}
                    </td>
                    <td>{{ item.winning_pool_title }}</td>
                  </tr>
                  <tr v-show="search.result_show == 2">
                    <td colspan="2">{{ $t('noData') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="center" style="text-align: center" v-show="search.result_show == 1">
              <div id="pages">
                <PageModule :totalPages="total_page" :currentPage="currentPage" @pagechanged="onPageChange" />
              </div>
            </div>
          </div>
          <div class="ttl">
            <img src="~@/assets/ttl02.png" alt="" v-if="lang==='cn'" />
            <img src="~@/assets/ttl02e.png" alt="" v-if="lang==='en'" height="100" />
          </div>
          <p class="explanation" v-html="description_html">
          </p>
        </div>
      </div>

      <div id="bgDiv" class="cover" style="display: none"></div>
      <div class="loading" style="display: none"><img src="~@/assets/loading.gif" /></div>
      <div class="popBox">
        <div class="img" v-if="nomoney">
          <img src="~@/assets/pop_nomoney.png" alt="" v-if="lang==='cn'" />
          <img src="~@/assets/pop_nomoneye.png" alt="" v-if="lang==='en'" height="411" />
          <div>{{ $t('betterLuck') }}</div>
        </div>
        <div class="img" v-else>
          <img src="~@/assets/pop_img.png" alt="" v-if="lang==='cn'" />
          <img src="~@/assets/pop_imge.png" alt="" v-if="lang==='en'" height="411" />
          <div v-html="$t('hj', { Prize: rollResult })"></div>
        </div>
        <div class="close">
          <a href="javascript:;" @click="closePopBox">
            <img src="~@/assets/close.png" alt="" />
          </a>
        </div>
      </div>
      <audio id="music_win" :src="winMusicSrc">
        你的浏览器不支持audio标签。
      </audio>
      <audio id="music_rotate" :src="rotateMusicSrc">
        你的浏览器不支持audio标签。
      </audio>

    </div>
    <transition name="fade">
      <Login v-show="showLoginModal" @close="closeModal" @customAlert="customAlert" />
    </transition>
  </div>
</template>

<script>
import Login from './LoginModule.vue';
import $ from 'jquery'
import PageModule from './PageModule.vue';

// 抽奖对象配置
var luck = {
  index: -1, // 转动后停留位置，下一次转动的起点位置
  count: 0, //总共有多少个位置
  timer: 0, //setTimeout的ID,用clearTimeout清除
  speed: 20, //初始转动速度
  times: 0, //转动次数
  cycle: 80, //转动基本次数（即至少需要转动多少次再进入抽奖环节）
  prize: -1, //中奖位置
  init: function () {
    if ($("#luck").find(".luck-unit").length > 0) {
      let $luck = $("#luck"); // 拿到抽奖容器
      let $units = $luck.find(".luck-unit"); //拿到所有抽奖格子
      this.count = $units.length;
      // 初始化起点位置
      $luck
        .find(".luck-unit-" + this.index)
        .addClass("active");
    }
  },
  // 转格子（操作样式）
  roll: function () {
    $("#luck")
      .find(".luck-unit-" + this.index)
      .removeClass("active");
    this.index += 1;
    if (this.index > this.count - 1) {
      this.index = 0;
    }
    $("#luck")
      .find(".luck-unit-" + this.index)
      .addClass("active");
    return false;
  },
  stop: function () {
    this.prize = this.index;
    return false;
  },
}

export default {
  name: 'MobileModule',
  data() {
    return {
      remain: 0,
      showLoginModal: false, // 是否登录
      isLogin: false,
      onLink: '',
      info: {},

      description_html: '',
      // 活动对象
      activeInfo: null,
      /*老虎机查询对象*/
      search: {
        history_list: [],
        dialogShow: false,
        result_show: 1, //0=初始，1=有数据，2=无数据
      },
      order: "",
      activityImg: '',
      fklhj_logo: '',
      fklhj_background: '',
      giftArr: [],

      isGoods: false, // 是否是商品(奖励列表中包含了奖励金额跟商品)
      goodsName: '',// 商品名称
      rollResult: "0.00",
      prize: -1, //中奖位置
      priceIndex: 0, // 转动后停留位置，下一次转动的起点位置
      nomoney: false,
      rotateMusicSrc: require('@/assets/rotate.mp3'),
      winMusicSrc: require('@/assets/win.mp3'),
      /** 派彩状态枚举 */
      EnumAwardStatus: {
        0: "审核中",
        1: "已派彩"
      },
      total_page: 10,
      currentPage: 1,
      lang: this.$i18n.locale
    }
  },
  computed: {
    computedImage() {
      return this.activityImg ?
        require(`@/assets/${this.activityImg}`) : '';
    },
    IsPC() { // 判断移动端
      // 获取设备信息
      const userAgent = navigator.userAgent;
      const screenWidth = screen.width;
      const viewportWidth = window.innerWidth;
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      // 常见的移动设备用户代理关键词
      const mobileKeywords = [
        'Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry',
        'Windows Phone', 'Mobile', 'Tablet'
      ];
      const isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword));
      // 额外的检测：触摸支持和屏幕尺寸
      const hasTouch = isTouchDevice;
      const isSmallScreen = viewportWidth < 768;
      if (isMobile || hasTouch && isSmallScreen) {
        return false
      }
      // 如果是平板设备（基于屏幕尺寸和用户代理）
      if ((isMobile && screenWidth >= 768) ||
        (userAgent.includes('iPad') || userAgent.includes('Tablet'))) {
        return true
      }
      return true
    }
  },
  components: {
    Login,
    PageModule
  },
  mounted() {
    this.siteInitFun()
    this.checkActivityFun()
    this.poolFun()
    let _info = sessionStorage.getItem('info')
    if (_info) {
      this.getDetailFun()
    }
   
  },
  methods: {
    // 动态处理文本长度
    formatPrizeName(text, maxChars = 35, maxLines = 2) {
      if (text.length <= maxChars) {
        return text;
      }
      
      // 计算每行大约的字符数
      const charsPerLine = Math.floor(maxChars / maxLines);
      
      if (text.length > maxChars) {
        // 截断并添加省略号
        return text.substring(0, maxChars - 3) + '...';
      }
      
      return text;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getSearchHistory()
    },
    fillZero(num) {
      return num < 10 ? `0${num}` : num;
    },
    getDateFormatter(timestamp) {
      const date = timestamp ? new Date(timestamp * 1000) : new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      return `${year}-${this.fillZero(month)}-${this.fillZero(day)} ${this.fillZero(hours)}:${this.fillZero(minutes,)}:${this.fillZero(seconds)}`;
    },
    getActiveDate() {
      let currentTime = parseInt(new Date().valueOf() / 1000);
      let endTime = Number(this.activeInfo.end_time)
      if (currentTime >= endTime) {
        this.customAlert(this.$t('yjs'));
        return true;
      }
      return false;
    },
    // 转格子（操作中奖）
    async roll() {
      luck.times += 1;
      // 已抽到奖
      if (
        luck.times > luck.cycle + 10 &&
        luck.prize == luck.index
      ) {
        clearTimeout(luck.timer);
        luck.times = 0;
        luck.speed = 20;
        luck.cycle = 80;
        luck.index = -1;
        luck.prize = -1;
        var music = document.getElementById("music_rotate");
        music.pause();
        music.currentTime = 0;
        setTimeout(function () {
          document.getElementById("music_win").play();
          $(".cjBtn").css("pointer-events", "all");  //设置鼠标事件可用
          // 显示中奖结果弹窗
          $(".cover,.popBox").fadeIn(function () {
            $(".cover,.popBox").find(".img");
          });
        }, 100);
      } else {
        // 未抽到奖（旋转格子、操作旋转速度）
        luck.roll();
        if (luck.times < luck.cycle) {
          // 抽到前加速
          luck.speed -= 10;
        } else {
          if (
            luck.times > luck.cycle + 10 &&
            ((luck.prize === 0 && luck.index == 7) ||
              luck.prize == luck.index + 1)
          ) {
            luck.speed += 220;
          } else {
            luck.speed += 20;
          }
        }
        if (luck.speed < 40) {
          luck.speed = 40;
        }
        // 递归旋转老虎机格子函数
        luck.timer = setTimeout(this.roll, luck.speed);
      }
    },
    // 处理老虎机中奖 
    async handleLuckySpinAward() {
      if (!this.isLogin) return this.showLoginModal = true
      if (this.getActiveDate()) return;
      if(this.remain < 1) return this.customAlert(this.$t('csbwk'))
      $(".cover,.loading").fadeIn();
      $(".cjBtn").css("pointer-events", "none");  //设置鼠标事件不可用
      await this.$axios.post(`/FKLHJUser/spin`, { username: this.info.username }).then(async (data) => {
        $(".cover,.loading").fadeOut();
        if (data.status === 200 && data.data.status) {
          const { winning_pool_title, winning_pool_id, winning_pool_is_win } = data.data.data
          this.giftArr.map((item, index) => {
            // 获取奖品在奖品列表中的索引位置
            if (item.id == winning_pool_id) {
              luck.prize = index;
              this.isGoods = item;
              if (this.isGoods) {
                this.goodsName = item.winning_pool_title;
              }
            }
          });
          this.rollResult =winning_pool_title // 奖品价值
          this.nomoney =  winning_pool_is_win ? false : true
          // 播放老虎机音乐
          document.getElementById("music_rotate").play();
          // 开始旋转老虎机格子
          await this.roll();
          // 剩余次数-1
          this.remain -= 1;
        } else {
          $(".cjBtn").css("pointer-events", "all");  //设置鼠标事件可用
          this.customAlert(data.data.msg);
        }
      })
        .catch((error) => {
          $(".cjBtn").css("pointer-events", "all");  //设置鼠标事件可用
          if (error.response) {
            this.customToast("请求失败，请联系客服！", false);
          } else if (error.request) {
            // 请求已经成功发起，但没有收到响应
          } else {
            // 发送请求时出了点问题
          }
        });
    },
    fadeIn(element, duration) {
      element.style.display = 'block';
      element.style.opacity = 0;

      let start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const opacity = Math.min(progress / duration, 1);
        element.style.opacity = opacity;

        if (progress < duration) {
          window.requestAnimationFrame(step);
        }
      }

      window.requestAnimationFrame(step);
    },
    closePopBox: function () {
      $(".cover,.popBox").fadeOut();
    },
    closeSearchDialog() {
      $("#msgDiv").fadeOut(() => {
        this.search.dialogShow = false;
      });
      $("#bgDiv").fadeOut();
    },
    showDetail() {
      // 记录
      if (this.isLogin) {
        this.getSearchHistory()
        this.fadeIn(document.getElementById('msgDiv'), 1000);
        this.search.dialogShow = true;
      } else this.logFun()
    },
    async getSearchHistory() {
      await this.$axios.post('/FKLHJUserLog/getList', { username: this.info.username, page_size: 10, page: this.currentPage }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { list, total_page, page} = r.data.data
            if (list.length) this.search.result_show = 1
            this.search.history_list = list
            this.total_page = total_page
            this.currentPage = page
          } else {
            this.search.result_show = 2
            this.customToast(msg)
          }
        }
      })
    },
    getCurrentActivityImg(currentStatus) {
      switch (currentStatus) {
        // 活动未开启
        case 1:
          this.activityImg = this.lang === 'cn' ? "img08.png" : "img08e.png";
          break;
        // 距离活动开始倒计时
        case 2:
          this.activityImg = this.lang === 'cn' ? "img09.png" : "img09e.png";
          break;
        // 活动已过期
        case 3:
          this.activityImg = this.lang === 'cn' ? "img08.png" : "img08e.png";
          break;
        // 距离活动结束倒计时
        case 4:
          this.activityImg = this.lang === 'cn' ? "img07.png" : "img07e.png";
          break;
      }
    },
    getSystemOptions(currentTime, endDateDay, status) {
      //每天的倒计时
      var times = 0;
      var interval = setInterval(() => {
        this.showtime1(currentTime, endDateDay, status, times, interval);
        times += 1;
      }, 995)
    },
    showtime1(currentTime, endDateDay, status, times, interval) {
      if (status == 1 || status == 3) {
        clearInterval(interval);
        document.getElementById('date01').textContent = '0';
        document.getElementById('date02').textContent = '0';
        document.getElementById('date03').textContent = '0';
        document.getElementById('date04').textContent = '0';
      } else {
        var leftTime = endDateDay - currentTime - times * 1000;  //距离结束时间的毫秒数
        if (leftTime <= 0) {
          clearInterval(interval);
          location.reload();
        } else {
          let leftd = Math.floor(leftTime / (1000 * 60 * 60 * 24)),  //计算天数
            lefth = Math.floor(leftTime / (1000 * 60 * 60) % 24),  //计算小时数
            leftm = Math.floor(leftTime / (1000 * 60) % 60),  //计算分钟数
            lefts = Math.floor(leftTime / 1000 % 60);  //计算秒数
          document.getElementById('date01').textContent = leftd;
          document.getElementById('date02').textContent = lefth;
          document.getElementById('date03').textContent = leftm;
          document.getElementById('date04').textContent = lefts;
        }
      }
    },
    applyImage(url) {
      // 应用图片背景
      if (url) {
        const body = document.body;
        body.style.backgroundImage = `url(${url})`;
        body.style.backgroundPosition = 'center top';
        body.style.backgroundRepeat = 'no-repeat';
        body.style.backgroundColor = 'rgb(34, 34, 34)';
      } else {
        alert('请输入有效的图片URL');
      }
    },
    //提示 
    customToast(content, showTilte, title, width, top) {
      if (content == undefined) {
        content = "";
      }
      if (title == undefined) {
        title = this.$t('wxts');
      }
      if (width == undefined) {
        width = "360px";
      }
      if (top == undefined) {
        top = "50%";
      }
      this.$dialog.confirm(content, showTilte ? title : "", this.$t('qd'), {
        dialogWidth: width,
        dialogTop: top,
      });
    },
    customAlert(content, title, width, top) {
      if (content == undefined) {
        content = "";
      }
      if (title == undefined) {
        title = this.$t('wxts');
      }
      if (width == undefined) {
        width = "360px";
      }
      if (top == undefined) {
        top = "50%";
      }
      this.$dialog.alert(content, title, this.$t('qd'), { dialogWidth: width, dialogTop: top });
    },
    closeModal(visible) {
      if (visible === 'showLoginModal') {
        let _info = sessionStorage.getItem('info')
        if (_info) {
          this.isLogin = true
          this.info = JSON.parse(_info)
          this.remain = this.info.total_draw_times
        }
      }
      this[visible] = false
    },
    async poolFun() {
      // 奖品设置
      $(".cover,.loading").fadeIn();
      await this.$axios.post("/FKLHJWinningPool/getAllList", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { list } = r.data.data
            if (this.lang === 'en') {
                 // 英语奖品名称处理
              list.forEach(item => {
                if (item.title_en) {
                  item.title = item.title_en
                }
              });
            } else if (this.lang === 'tl') {
                 // 菲律宾奖品名称处理
              list.forEach(item => {
                if (item.title_tl) {
                  item.title = item.title_tl
                }
              });
            } 
            this.giftArr = list
            luck.count = list.length
            // 初始化抽奖对象
            this.$nextTick(() => {
              luck.init()
            })
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      $(".cover,.loading").fadeOut();
    },
    async siteInitFun() {
      // logo & backaground
      $(".cover,.loading").fadeIn();
      await this.$axios.post("/Site/init", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { cs_url, fklhj_logo, fklhj_pc_background} = r.data.data
            this.onLink = cs_url
            if (fklhj_pc_background) {
              this.applyImage(`${this.$Domain}${fklhj_pc_background}`)
            }
            if (fklhj_logo) {
              this.fklhj_logo = `${this.$Domain}${fklhj_logo}`
            }
            this.handleIcoCreate(r.data.data)
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      $(".cover,.loading").fadeOut();
    },
    handleIcoCreate(siteObj) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${this.$Domain}${siteObj.fklhj_logo}`
      let head = document.head || document.getElementsByTagName('head')[0]
      head.appendChild(link);
      let title = document.createElement('title')
      title.innerHTML = siteObj.name
      head.appendChild(title);
    },
    async checkActivityFun() {
      // 倒计时
      $(".cover,.loading").fadeIn();
      await this.$axios.post("/FKLHJUser/checkActivity", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { start_time, end_time } = JSON.parse(r.data.data.setting)
            this.activeInfo = r.data.data
            const { description_html , description_html_en, description_html_tl } = r.data.data
            this.description_html = this.lang==='cn' ? description_html : this.lang==='en' && description_html_en ? description_html_en : this.lang==='tl' && description_html_tl ? description_html_tl : description_html
            let startTime = Number(start_time) * 1000
            let endTime = Number(end_time) * 1000
            let currentTime = Math.floor(new Date().getTime())
            // 活动未开始
            if (currentTime < startTime) {
              this.getCurrentActivityImg(2)
              this.getSystemOptions(currentTime, startTime)
            } else if (currentTime > endTime) {
              // 活动已经结束
              this.getCurrentActivityImg(3)
            } else {
              // 活动已经开始-未结束
              this.getCurrentActivityImg(4)
              this.getSystemOptions(currentTime, endTime)
            }
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      $(".cover,.loading").fadeOut();
    },
    async getDetailFun() {
      // 登录
      $(".cover,.loading").fadeIn();
      let username = this.userNameFun()
      if (!username) return
      await this.$axios.post('/FKLHJUser/getDetail', { username: username }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            this.isLogin = true
            sessionStorage.setItem('info', JSON.stringify(r.data.data))
            this.info = r.data.data
            this.remain = r.data.data.total_draw_times
          } else this.errorFun(msg)
        }
      })
      $(".cover,.loading").fadeOut();
    },
    userNameFun() {
      let _info = sessionStorage.getItem('info')
      if (_info) {
        this.isLogin = true
        let temp = JSON.parse(_info)
        return temp.username
      }
      return ''
    },
    logFun() {
      if (!this.isLogin) {
        this.showLoginModal = true
      } else this.showLogModal = true
    },
    errorFun(msg) {
      this.customToast(msg)
    },
    logOut() {
      sessionStorage.clear();
      location.reload();
    },
    truncateText(text) {
      const maxLength = 8;
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    toggleText(element) {
      const span = element.currentTarget
      const fullText = span.getAttribute('data-full-text');
      // Check if the current text ends with "..."
      if (span.textContent.endsWith('...')) {
        // If it's truncated, show the full text
        span.textContent = fullText;
      } else {
        // If it's not truncated, show the truncated version
        span.textContent = this.truncateText(fullText);
      }
    }
  },

  watch: {
    currentPage(newVal) {
      if (newVal < 1) this.currentPage = 1;
      if (newVal > this.total_page) this.currentPage = this.total_page;
    },
    total_page(newVal) {
      if (newVal < 1) this.total_page = 1;
      if (this.currentPage > newVal) this.currentPage = newVal;
    }
  }
};
</script>
<style scoped lang="less">
.prize-name {
  /* 基础样式 */
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  color: #333;
  
  /* 布局控制 */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  text-align: center;
  
  /* 多行文本控制 */
  overflow: hidden;
  word-break: break-word;
  -webkit-line-clamp: 2; /* 限制最多2行 */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  
  /* 尺寸限制 */
  max-width: 100%;
  min-height: 36px; /* 两行文本的最小高度 */
  
  /* 字符长度限制的备用方案 */
  max-width: 35ch; /* 大约35个字符的宽度 */
}

/* 单行显示的变体 */
.prize-name.single-line {
  -webkit-line-clamp: 1;
  line-clamp: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: auto;
}

/* 长文本自动缩小字体 */
.prize-name.long-text {
  font-size: 12px;
}

/* 响应式处理 */
@media (max-width: 768px) {
  .prize-name {
    font-size: 12px;
    min-height: 32px;
    max-width: 30ch;
  }
}

/* 超长文本的特殊处理 */
.prize-name.very-long {
  font-size: 11px;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  min-height: 48px;
}

/* 容器样式示例 */
.prize-container {
  width: 200px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>